<template>
    <div class="content-box">
        <div class="element-wrapper pb-0">
            <div class="element-header">
                <div class="row">
                    <div class="col-md 8 mr-auto">
                        <h3 class>Global - Detalhes Faturas</h3>
                    </div>
                    <div class="col-auto">
                        <b-btn @click="exportar">
                          <i class="fas fa-file-excel"></i>  Exportar
                        </b-btn>
                        <b-button @click="voltar">Voltar</b-button>
                    </div>
                </div>
            </div>
        </div>

        <filtro-fatura :find="find"></filtro-fatura>

        <div class="col mt-3">
            <div class="element-wrapper pb-0">
                <b-card>
                    <div class="container">
                        <div class="row">
                            <div class="col">
                                <label for>Total Faturas</label>
                                <h5>{{resumoFatura.qtdTotalFaturas}}</h5>
                            </div>
                            <div class="col">
                                <label for>Faturas Pagas</label>
                                <h5>{{resumoFatura.qtdFaturasPagas}}</h5>
                            </div>
                            <div class="col">
                                <label for>Faturas Aguardando Pagamento</label>
                                <h5>{{resumoFatura.qtdFaturasAguardando}}</h5>
                            </div>
                            <div class="col">
                                <label for>Faturas Vencidas</label>
                                <h5>{{resumoFatura.qtdFaturasVencidas}}</h5>
                            </div>
                        </div>
                    </div>
                </b-card>
            </div>
        </div>

        <div class="col mt-3">
            <b-card>
                <b-card-body class="p-1">
                    <div class="row">
                        <b-col class="my-1">
                            <b-pagination
                                    v-if="pagination.totalRows > 10"
                                    v-model="pagination.page"
                                    :total-rows="pagination.totalRows"
                                    :per-page="pagination.limit"
                                    align="fill"
                                    size="sm"
                                    class="my-0"
                            ></b-pagination>
                        </b-col>
                    </div>
                    <div class="row">
                        <div class="col">
                            <b-table show-empty emptyText="Não há itens para exibir"
                                     ref="table" id="my-table"
                                     selected-variant="success"
                                     :current-page="pagination.page"
                                     :per-page="pagination.limit"
                                     :busy="loading" :items="detalhesFaturas" responsive
                                     :fields="fields" small
                                     striped hover>
                                <template slot="[formadePagamento]" slot-scope="row">
                                    <b-badge variant="warning">
                                      {{getCharge(row.item.vindiInfo.charges).payment_method.public_name}}
                                    </b-badge>
                                </template>
                                <template slot="[nome]" slot-scope="row">
                                    {{row.item.pedido.client.name}}<br>
                                    <small>{{'CPF: ' + row.item.pedido.client.cpf}}</small>
                                </template>
                                <template slot="[plano]" slot-scope="row">
                                    {{row.item.pedido.plano.price | money }}
                                </template>
                                <template slot="[valorPago]" slot-scope="row">
                                    {{getValorPago(row.item.vindiInfo) | money }}
                                </template>
                                <template slot="[valorDrAchei]" slot-scope="row">
                                    {{getValorDrAchei(row.item) | money }}
                                </template>
                                <template slot="[valorImposto]" slot-scope="row">
                                  {{getValorImposto(row.item) | money }}
                                </template>
                                <template slot="[valorDrAcheiComImposto]" slot-scope="row">
                                  {{getValorDrAcheiComImposto(row.item) | money }}
                                </template>
                                <template slot="[valorTaxaAdesao]" slot-scope="row">
                                    {{getValorTaxaAdesao(row.item) | money }}
                                </template>
                                <template slot="[valorEmpresa]" slot-scope="row">
                                    {{getValorEmpresa(row.item) | money }}
                                </template>
                                <template class="text-center" slot="[statusFatura]" slot-scope="row">
                                    <b-badge :variant="getTextStatusPagamento(row.item) === 'Pago' ? 'success' : 'warning'">{{getTextStatusPagamento(row.item)}}</b-badge>
                                </template>
                                <template slot="[actions]" slot-scope="row">
                                    <b-button title="Visualizar" variant="light" @click.stop=" $router.push({name: 'PedidoDetail', query:{id: row.item.pedido._id}})">
                                        <i class="fas fa-search"></i>
                                    </b-button>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </b-card-body>
            </b-card>
        </div>

    </div>
</template>

<script>
    import filtroFatura from '@/components/financeiro/FiltroFatura';
    import moment from "moment";

    export default {
        name: "detalhesFaturas",
        computed: {
            loading() {
                return this.$store.getters.loading;
            }
        },
        async mounted() {
            this.resumoFatura = await this.$store.dispatch('resumoFaturas')
                .then(response => response.data);
        },
        data() {
            return {
                resumoFatura: {
                    qtdTotalFaturas: 0,
                    qtdFaturasPagas: 0,
                    qtdFaturasAguardando: 0,
                    qtdFaturasVencidas: 0
                },
                pagination: {
                    limit: 10,
                    page: 1,
                    totalRows: 0
                },
                fields: [
                    {key: 'pedido.idPedidoVindi', label: 'ID Pedido', sortable: true},
                    {key: 'nome', label: 'Nome'},
                    {key: 'formadePagamento', label: 'Método Pagamento', sortable: true},
                    {key: 'pedido.createdAt', label: 'Data Cadastro', sortable: true, formatter: this.createdAtFormatter},
                    {key: "vindiInfo.due_at", label:"Data Vencimento Fatura", sortable:true,formatter:this.createdAtFormatter},
                    {key: "dataPagamento", label:"Data Pagamento", sortable:true,formatter:this.createdAtFormatter},
                    {key: "statusFatura", label:"Status da Fatura", sortable: true},
                    {key: "parcela", label:"Parcela", sortable: true},
                    {key: 'plano', label: 'Valor Plano', sortable: true},
                    {key: "valorPago", label:"Valor Pago", sortable: true},
                    {key: "valorTaxaAdesao", label:"Taxa Adesão", sortable: true},
                    {key: "valorDrAchei", label:"Valor DrAchei", sortable: true},
                    {key: "valorImposto", label:"Valor Imposto", sortable: true},
                    {key: "valorDrAcheiComImposto", label:"Valor DrAchei + Imposto", sortable: true},
                    {key: "valorEmpresa", label:"Valor Empresa", sortable: true},
                    {key: 'actions', label: ''}
                ]
            }
        },
        methods: {
            createdAtFormatter(value){
                if (value) {
                    return moment(value).format("DD/MM/YYYY");
                }
                return ''
            },
            voltar() {
                window.history.back();
            },
            detalhesFaturas(ctx) {
                try {
                    this.$store.dispatch("setLoading", true);

                    this.pagination.page = ctx.currentPage;
                    this.pagination.limit = ctx.perPage;

                    this.$store.dispatch('setPagination', this.pagination);

                    return this.$store.dispatch('findDetalhesFaturas')
                        .then(response => {
                            const result = response.data;
                            this.pagination.totalRows = result.totalCount;
                            return result.data || [];
                        });
                } catch (e) {
                    // eslint-disable-next-line
                    console.log(e);
                    alert(e.message);
                } finally {
                    this.$store.dispatch("setLoading", false);
                }
            },
            async find() {
              this.pagination.page = 1;
                this.resumoFatura = await this.$store.dispatch('resumoFaturas')
                    .then(response => response.data);
                this.$store.dispatch("setLoadingTable", true);
                this.$root.$emit('bv::refresh::table', 'my-table')
                this.$store.dispatch("setLoadingTable", false);
            },
            getTextFormaPagamento(formaPagamento) {
                switch (formaPagamento) {
                    case 'cartaoCredito':
                        return 'Cartão Crédito'
                    default:
                        return formaPagamento;
                }
            },
            isVencida(fatura) {
                let dataVencimento = new Date(fatura.dataVencimento);
                return moment().isSameOrAfter(dataVencimento);
            },
            getCharge(charges) {
                if (!charges) {
                    return {}
                }
                if (charges.length === 1) {
                    return charges[0];
                }

                return charges.find(charge => charge.status === 'pending' || charge.status === 'paid')
            },
            getValorPago(vindiInfo) {
                const charge = this.getCharge(vindiInfo.charges);
                if (charge) {
                    return Number(charge.amount);
                }
                return 0;
            },
            getValorImposto(fatura){
              const plano = fatura.pedido.plano;
              const pctImposto = plano.valorImposto / plano.valorRepasse;

              return this.getValorDrAchei(fatura) * pctImposto;
            },
            getValorDrAchei(fatura) {
              if (fatura.parcela === 1) {
                const plano = fatura.pedido.plano;
                const vlCobranca = Number(fatura.charge.amount) - plano.valorTaxaAdesao;
                const pctRepasse = plano.valorRepasse / plano.price;

                return (pctRepasse * vlCobranca);
              } else {
                const plano = fatura.pedido.plano;
                const vlCobranca = Number(fatura.charge.amount);
                const pctRepasse = plano.valorRepasse / plano.price;

                return (pctRepasse * vlCobranca);
              }
            },
            getValorDrAcheiComImposto(fatura) {
              return this.getValorDrAchei(fatura) + this.getValorImposto(fatura);
            },
            getValorTaxaAdesao(fatura) {
                if (fatura.parcela === 1) {
                    const plano = fatura.pedido.plano;
                    return plano.valorTaxaAdesao;
                }
                return 0;
            },
            getValorEmpresa(fatura) {
                return this.getValorPago(fatura.vindiInfo) - this.getValorDrAcheiComImposto(fatura);
            },
            getTextStatusPagamento(fatura) {
                const statusVindi = fatura.statusFatura;
                switch (statusVindi) {
                    case 'processing':
                        return 'Processando pagamento'
                    case 'failure':
                        return 'Falha ao processar pagamento'
                    case 'rejected':
                        return 'Pagamento rejeitado'
                    case 'pending':
                    case 'waiting':
                        if (this.isVencida(fatura)) {
                            return 'Vencida'
                        }
                        return 'Aguardando pagamento';
                    case 'success':
                    case 'paid':
                        return 'Pago'
                    default:
                        return statusVindi
                }
            },
            async exportar() {
              this.$store.dispatch("setLoading", true);
              await this.$store.dispatch('findDetalhesFaturasExcel');
              this.$store.dispatch("setLoading", false);
            }
        },
        components: {
            filtroFatura
        }
    }
</script>

<style scoped>

</style>
